module.exports = __webpack_public_path__ + "static/media/car-tire.b2cec53c.jpg";